/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { globalBreak } from '@/styles/break';
import { SxProps } from '@mui/material';

export const error404TypographySX: SxProps = {
	p: 2,
	position:'relative'
};

export const error404LinkSX: SxProps = {
	fontSize: globalBreak({ mobile: '16px', desktop: '24px' }),
    width: globalBreak({ mobile: 'auto', desktop: '25%' }),
	backgroundColor:'#000', 
	color:'#fff',
	position:'absolute', 
	right:globalBreak({ mobile: '7%', desktop: '20%' }),
	bottom:globalBreak({ mobile: '-2%', desktop: '4%' }),
	lineHeight: globalBreak({ mobile: 'normal', desktop: 'inherit'}),
	paddingTop: globalBreak({ mobile: '8px', desktop: 'inherit'}),
	paddingBottom: globalBreak({ mobile: '8px', desktop: 'inherit'})
}
